'use client';

import React from 'react';

import { ForgotPasswordForm, ResetPasswordForm } from '@/components/V2/Auth';
import { ForgotPasswordProvider, useForgotPasswordContext } from '@/contexts/ForgotPasswordContext';
import cn from '@/helpers/utils/classNames';
import { useAppContext } from '@/layouts/AppProvider';

import EnterSecurityCode from './components/EnterSecurityCode';

const ForgotPasswordContent = () => {
  const { currentStep, customerDetail, handleEnterCodeVerify, handleEnterCodeBack } = useForgotPasswordContext();

  switch (currentStep) {
    case 'forgot':
      return <ForgotPasswordForm />;
    case 'verify':
      return (
        <EnterSecurityCode
          onVerify={handleEnterCodeVerify}
          onBack={handleEnterCodeBack}
          inPage={true}
          customer={customerDetail}
        />
      );
    case 'reset':
      return <ResetPasswordForm />;
    default:
      return <ForgotPasswordForm />;
  }
};

const ForgotPasswordContainer = () => {
  const { isBackOffice } = useAppContext();
  return (
    <ForgotPasswordProvider>
      <div
        className={cn('v2-flex v2-items-center v2-justify-center v2-px-4 v2-py-6 md:v2-py-8 md:v2-px-8', {
          'backoffice-login-background v2-inset-0 v2-fixed': isBackOffice,
          'v2-bg-white v2-min-h-full md:v2-min-h-screen': !isBackOffice,
        })}
      >
        <div className="v2-bg-white v2-px-4 v2-py-6 md:v2-py-8 md:v2-px-8 v2-shadow-xl v2-rounded-xl v2-max-w-[640px] v2-w-full">
          <ForgotPasswordContent />
        </div>
      </div>
    </ForgotPasswordProvider>
  );
};

export default ForgotPasswordContainer;
